import { AdditionalFields } from '../domain/entities/inspirationalTemplate';
import { INSPIRATIONAL_TEMPLATE_MAP as EN_MAP } from './inspirationalTemplateMap.en';

export const INSPIRATIONAL_TEMPLATE_MAP: Record<string, AdditionalFields> = {
  'b991864c-cd05-498d-85e2-03459fdeb6ec': {
    backgroundColor: '#F3FFE0',
    shortDescription:
      'Obtén inspiración al ver cómo esta página única detiene el desplazamiento y sorprende al no cumplir con las expectativas.',
    features: [
      'Video transparente',
      'Animación del efecto cursor',
      'Marquesina de texto',
      'Código personalizado',
      'Cuadrícula CSS',
      'Biblioteca de recursos para descargar',
    ],
    inspirationalAssets:
      EN_MAP['b991864c-cd05-498d-85e2-03459fdeb6ec'].inspirationalAssets,
  },
  'd674b741-2412-4260-af3f-c5f0e964fcd5': {
    backgroundColor: '#F4EDFF',
    shortDescription:
      'Alimenta tu imaginación y prepárate para despegar con este magnífico sitio de exploración espacial.',
    features: [
      'Animación de desplazamiento',
      'Animación de bucle',
      'Desplazamiento horizontal',
      'Efecto cursor',
      'CSS personalizado',
    ],
    inspirationalAssets:
      EN_MAP['d674b741-2412-4260-af3f-c5f0e964fcd5'].inspirationalAssets,
  },
  '8de718ac-8cc4-4b69-88ab-4d92920c37a2': {
    backgroundColor: '#FFE8E4',
    shortDescription:
      'Marca la diferencia y agrega movimiento con marquesinas de texto dinámicas.',
    features: [
      'Marquesina de texto',
      'Animación de desplazamiento',
      'Animación de bucle',
      'Animación de entrada',
      'Efectos de desplazamiento del fondo',
      'Cuadrícula CSS',
    ],
    inspirationalAssets:
      EN_MAP['8de718ac-8cc4-4b69-88ab-4d92920c37a2'].inspirationalAssets,
  },
  '50d5ca42-112a-466a-aca2-fd8bc927a965': {
    backgroundColor: '#E2FFE2',
    shortDescription:
      'Inspírate con efectos de desplazamiento y animaciones que mantendrán a los lectores interesados en el mensaje de esta organización sin fines de lucro.',
    features: [
      'Animación de desplazamiento',
      'Animación de bucle',
      'Animación de entrada',
      'Video transparente',
      'Cuadrícula CSS',
      'Pila',
    ],
    inspirationalAssets:
      EN_MAP['50d5ca42-112a-466a-aca2-fd8bc927a965'].inspirationalAssets,
  },
  '31ec1ed2-9432-46e2-8175-5e4ccab9b5b9': {
    backgroundColor: '#FFE6F1',
    shortDescription:
      'Dale vida a los hechos, estadísticas y cifras usando técnicas de scrollytelling.',
    features: [
      'Animación de desplazamiento',
      'Animación de bucle',
      'Animación de entrada',
      'Marquesina de texto',
      'Degradado del fondo',
      'Efectos de desplazamiento del fondo',
    ],
    inspirationalAssets:
      EN_MAP['31ec1ed2-9432-46e2-8175-5e4ccab9b5b9'].inspirationalAssets,
  },
  '498fe8fb-46ba-45a5-9346-3bb5b1c9f61c': {
    backgroundColor: '#E6F2FF',
    shortDescription:
      'Descubre los misterios del zodíaco y deja que este sitio de astrología sea la musa de tu próximo proyecto.',
    features: [
      'Efectos del cursor',
      'Posición adhesiva',
      'Desplazamiento horizontal',
      'Animación del desplazamiento',
      'Código personalizado',
    ],
    inspirationalAssets:
      EN_MAP['498fe8fb-46ba-45a5-9346-3bb5b1c9f61c'].inspirationalAssets,
  },
};
